// extracted by mini-css-extract-plugin
module.exports = {"personalTaxIncome":"style_personalTaxIncome__297_0","paragraphs":"style_paragraphs__3bie5","standAlone":"style_standAlone__2PrGw","subHeading":"style_subHeading__2lFAW"};